export let RolesModalLayoutJSON = [
  {
    name: "New",
    child: [
      {
        child: [
          {
            child: [
              {
                parentid: "1692362019775-col-1",
                elementid: "1692362079963",
                elementtype: "textfield",
              },
              {
                parentid: "1692362019775-col-1",
                elementid: "1692363731639",
                elementtype: "customSelect",
              },
            ],
            colpos: 1,
            parentid: "1692362019775-columns",
            elementid: "1692362019775-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1692362019775-col-2",
                elementid: "1692362083195",
                elementtype: "textarea",
              },
            ],
            colpos: 2,
            parentid: "1692362019775-columns",
            elementid: "1692362019775-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1692362014074-form",
        elementid: "1692362019775",
        elementtype: "columns",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1692362014074",
    description: "",
    elementtype: "others",
    "section-type": "form",
    linkedentitytype: -1,
  },
];
